import type { FunctionComponent } from 'react';
import type { TypeTextProps } from './types';

export const Description: FunctionComponent<TypeTextProps> = ({
  children,
  typographyClass = 'text-body-l',
}: TypeTextProps) => (
  <div
    className={`text-body ${typographyClass} text-neutrals-0 mb-8 md:w-[590px]`}
  >
    {children}
  </div>
);
